"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var softLockModalStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography;
    return ({
        root: {
            display: 'grid',
            fontFamily: typography.fontFamily,
            padding: '16px',
        },
        buttonContainer: {
            fontFamily: typography.fontFamily,
            maxWidth: '100%',
            textAlign: 'center',
        },
        button: {
            margin: '0 5px 0 5px',
        },
        message: {
            margin: 'auto',
            padding: '10px 0',
        },
        softLockContinueBtn: {},
    });
}, { name: 'Checkout4_SoftLockModal' });
exports.default = softLockModalStyles;
